/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;align-self:center;justify-self:center;padding:20px;height:100%;text-align:center;display:flex;flex-direction:column;justify-content:center;align-content:center;align-items:center}"];
export { styles as styles };
